import React from 'react';

import {
  CONCURRENCY_LABELS,
  PLAN_INTERVAL,
  PRODUCT_API_TESTING,
  PRODUCT_USAGE,
} from '../../constants';
import { formatThousand } from '../../utils/numbers';

interface Props {
  interval: string,
  productType: ProductType
  secondaryValue?: string | number
  value: string | number
}

const productAmountByProductType = (
  productType: string,
  interval: string,
  value: string | number,
  secondaryValue?: string | number,
) => {
  switch (productType) {
    case PRODUCT_API_TESTING:
      return `${value} ${CONCURRENCY_LABELS[productType].toLowerCase()}, ${formatThousand(secondaryValue as number)} executions/mo`;
    case PRODUCT_USAGE:
      return `${formatThousand(value as number, 'standard')} credits/${interval === PLAN_INTERVAL.YEAR ? 'yr' : 'mo'}`;
    default:
      return `${CONCURRENCY_LABELS[productType as ProductType]}: ${value}`;
  }
};

export const ProductAmount: React.FC<Props> = ({
  productType,
  interval,
  secondaryValue,
  value,
}) => (
  <div data-qa="summary-tile-product-amount">
    <strong>
      {productAmountByProductType(productType, interval, value, secondaryValue)}
    </strong>
  </div>
);
